import useAccess from "../../../authorization/hooks/useAccess.js";
import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { useSearchParams, useNavigate } from "react-router-dom";
// used--------------------
import HomeOutlinedIcon from "@mui/icons-material/HomeOutlined";
import DashboardOutlinedIcon from "@mui/icons-material/DashboardOutlined";
import AdminPanelSettingsOutlinedIcon from "@mui/icons-material/AdminPanelSettingsOutlined";
import NotificationsActiveOutlinedIcon from "@mui/icons-material/NotificationsActiveOutlined";
import ApiOutlinedIcon from "@mui/icons-material/ApiOutlined";
import BusinessOutlinedIcon from "@mui/icons-material/BusinessOutlined";
import CreditCardOutlinedIcon from "@mui/icons-material/CreditCardOutlined";
import PeopleOutlineIcon from "@mui/icons-material/PeopleOutline";
import LocationOnOutlinedIcon from "@mui/icons-material/LocationOnOutlined";
import ContactsOutlinedIcon from "@mui/icons-material/ContactsOutlined";
import TuneOutlinedIcon from "@mui/icons-material/TuneOutlined";
import BadgeOutlinedIcon from "@mui/icons-material/BadgeOutlined";
import SecurityOutlinedIcon from "@mui/icons-material/SecurityOutlined";
import SubscriptionsOutlinedIcon from "@mui/icons-material/SubscriptionsOutlined";
import PaymentOutlinedIcon from "@mui/icons-material/PaymentOutlined";
import HistoryOutlinedIcon from "@mui/icons-material/HistoryOutlined";
import ReceiptLongOutlinedIcon from "@mui/icons-material/ReceiptLongOutlined";
import PersonAddAltOutlinedIcon from "@mui/icons-material/PersonAddAltOutlined";
import NotificationsOutlinedIcon from "@mui/icons-material/NotificationsOutlined";
import KeyOutlinedIcon from "@mui/icons-material/KeyOutlined";
import DescriptionOutlinedIcon from "@mui/icons-material/DescriptionOutlined";
import WebhookOutlinedIcon from "@mui/icons-material/WebhookOutlined";
import TimelineOutlinedIcon from "@mui/icons-material/TimelineOutlined";
import SendOutlinedIcon from "@mui/icons-material/SendOutlined";
// ----------------------------
import AppsRoundedIcon from "@mui/icons-material/AppsRounded";
import SearchRoundedIcon from "@mui/icons-material/SearchRounded";
import SettingsOutlinedIcon from "@mui/icons-material/SettingsOutlined";
import DashboardRoundedIcon from "@mui/icons-material/DashboardRounded";
import TrackChangesRoundedIcon from "@mui/icons-material/TrackChangesRounded";
import Inventory2OutlinedIcon from "@mui/icons-material/Inventory2Outlined";
import DeleteOutlineRoundedIcon from "@mui/icons-material/DeleteOutlineRounded";
import AddRoundedIcon from "@mui/icons-material/AddRounded";
import ChevronRightRoundedIcon from "@mui/icons-material/ChevronRightRounded";
import KeyboardArrowDownRoundedIcon from "@mui/icons-material/KeyboardArrowDownRounded";
import FolderOutlinedIcon from "@mui/icons-material/FolderOutlined";
import DesignServicesOutlinedIcon from "@mui/icons-material/DesignServicesOutlined";
import WebOutlinedIcon from "@mui/icons-material/WebOutlined";
import LogoutRoundedIcon from "@mui/icons-material/LogoutRounded";
import CloudOutlinedIcon from "@mui/icons-material/CloudOutlined";
import RocketLaunchRoundedIcon from "@mui/icons-material/RocketLaunchRounded";
import MoreVertRoundedIcon from "@mui/icons-material/MoreVertRounded";
import AutoAwesomeRoundedIcon from "@mui/icons-material/AutoAwesomeRounded";

import "./clientProfileDashboard.css";
import ProfileDashboard from "./companies-profile-comps/ProfileDashboard";
import StaffWorkspace from "./companies-profile-comps/StaffWorkspace";
import { subscriptionProgress } from "./companies-profile-comps/BillingDashboard";

const primaryNavigation = [
  {
    id: "dashboard",
    label: "Overview",
    icon: <DashboardRoundedIcon />,
  },
  {
    id: "company-profile",
    label: "Company Profile",
    icon: <BusinessOutlinedIcon />,
  },
  {
    id: "access-control",
    label: "Staff Access Control",
    icon: <AdminPanelSettingsOutlinedIcon />,
  },
  {
    id: "activity",
    label: "Activity",
    icon: <TrackChangesRoundedIcon />,
  },
  {
    id: "billings",
    label: "Billing & Subscription",
    icon: <CreditCardOutlinedIcon />,
  },
  {
    id: "manage-notifications",
    label: "Manage Notifications",
    icon: <NotificationsActiveOutlinedIcon />,
  },
  {
    id: "add",
    label: "Public API (beta)",
    icon: <ApiOutlinedIcon />,
  },
];

const secondaryNavigation = [
  {
    id: "dashboard",
    title: "Overview",
    items: [
      {
        id: "overview",
        label: "Overview",
        icon: <CloudOutlinedIcon />,
        children: [
          {
            id: "my-overview",
            label: "My Overview",
          },
          {
            id: "recent-activity",
            label: "Recent Activity",
            
          },
        ],
      },

      {
        id: "starred-files",
        label: "Starred Files",
        icon: <FolderOutlinedIcon />,
        children: [],
        editable: true,
      },

      {
        id: "ui-ux-design",
        label: "UI & UX Design",
        icon: <DesignServicesOutlinedIcon />,
        children: [
          {
            id: "products-designs",
            label: "Products Designs",
            children: [
              {
                id: "course-dashboard",
                label: "Course Dashboard",
              },
              {
                id: "kds-dashboard",
                label: "KDS Dashboard",
              },
            ],
          },

          {
            id: "drapora-projects",
            label: "Drapora Projects",
          },
        ],
      },

      {
        id: "design-systems",
        label: "Design Systems",
        icon: <FolderOutlinedIcon />,
        children: [],
      },

      {
        id: "web-apps",
        label: "Web Apps",
        icon: <WebOutlinedIcon />,
        children: [],
      },
    ],
  },
  {
    id: "company-profile",
    title: "Company Profile",
    items: [
      {
        id: "business-information",
        label: "Business Information",
        icon: <BusinessOutlinedIcon />,
        children: [
          {
            id: "business-details",
            label: "Business Details",
          },
          {
            id: "contact-information",
            label: "Contact Information",
          },
        ],
      },

      {
        id: "business-address",
        label: "Business Address",
        icon: <LocationOnOutlinedIcon />,
        children: [
          {
            id: "primary-address",
            label: "Primary Address",
          },
          {
            id: "billing-address",
            label: "Billing Address",
          },
        ],
      },

      {
        id: "business-identity",
        label: "Business Identity",
        icon: <BadgeOutlinedIcon />,
        children: [
          {
            id: "business-logo",
            label: "Business Logo",
          },
          {
            id: "business-registration",
            label: "Registration Details",
          },
          {
            id: "tax-identity",
            label: "Tax Identification",
          },
        ],
      },

      {
        id: "company-contacts",
        label: "Company Contacts",
        icon: <ContactsOutlinedIcon />,
        children: [
          {
            id: "primary-contact",
            label: "Primary Contact",
          },
          {
            id: "support-contact",
            label: "Support Contact",
          },
        ],
      },

      {
        id: "company-preferences",
        label: "Company Preferences",
        icon: <TuneOutlinedIcon />,
        children: [
          {
            id: "general-preferences",
            label: "General Preferences",
          },
          {
            id: "date-time-preferences",
            label: "Date & Time",
          },
          {
            id: "regional-preferences",
            label: "Regional Preferences",
          },
        ],
      },
      {
        id: "company-locations",
        label: "Branches & Inventory",
        icon: <Inventory2OutlinedIcon />,
        children: [
          { id: "company-branches", label: "Branches" },
          { id: "company-inventories", label: "Inventories" },
          { id: "company-warehouses", label: "Warehouses" },
        ],
      },
      {
        id: "owner-profile",
        label: "Owner Profile",
        icon: <PeopleOutlineIcon />,
        children: [{ id: "founder-details", label: "Founder Details" }],
      },
    ],
  },

  {
    id: "access-control",
    title: "Staff Access Control",
    items: [
      {
        id: "staffs",
        label: "Staffs",
        icon: <PeopleOutlineIcon />,
        children: [
          {
            id: "all-staffs",
            label: "All Staffs",
            
          },
          {
            id: "active-staffs",
            label: "Active Staffs",
            
          },
          {
            id: "inactive-staffs",
            label: "Inactive Staffs",
            
          },
        ],
      },

      {
        id: "roles",
        label: "Roles",
        icon: <BadgeOutlinedIcon />,
        children: [
          {
            id: "all-roles",
            label: "All Roles",
            
          },
          {
            id: "system-roles",
            label: "System Roles",
          },
          {
            id: "custom-roles",
            label: "Custom Roles",
          },
          {
            id: "create-new-role",
            label: "Create New Role",
          },
        ],
      },

      {
        id: "permissions",
        label: "Permissions",
        icon: <AdminPanelSettingsOutlinedIcon />,
        children: [
          {
            id: "all-permissions",
            label: "All Permissions",
            
          },
          {
            id: "role-permissions",
            label: "Role Permissions",
          },
          {
            id: "staff-permissions",
            label: "Staff Permissions",
          },
        ],
      },

      {
        id: "security",
        label: "Security",
        icon: <SecurityOutlinedIcon />,
        children: [
          {
            id: "security-settings",
            label: "Security Settings",
          },
          {
            id: "login-security",
            label: "Login Security",
          },
          {
            id: "two-factor-authentication",
            label: "Two-Factor Authentication",
          },
          {
            id: "session-management",
            label: "Session Management",
          },
        ],
      },

      {
        id: "add-new-user",
        label: "Add New User",
        icon: <PersonAddAltOutlinedIcon />,
        children: [
          {
            id: "create-staff",
            label: "Create Staff",
          },
          {
            id: "invite-user",
            label: "Invite User",
          },
        ],
      },
    ],
  },
  {
    id: "billings",
    title: "Billing & Subscription",
    items: [
      {
        id: "subscription",
        label: "Subscription",
        icon: <SubscriptionsOutlinedIcon />,
        children: [
          {
            id: "current-plan",
            label: "Current Plan",
          },
          {
            id: "available-plans",
            label: "Available Plans",
          },
          {
            id: "plan-usage",
            label: "Plan Usage",
          },
        ],
      },

      {
        id: "payment-methods",
        label: "Payment Methods",
        icon: <PaymentOutlinedIcon />,
        children: [
          {
            id: "saved-payment-methods",
            label: "Saved Payment Methods",
          },
          {
            id: "add-payment-method",
            label: "Add Payment Method",
          },
        ],
      },

      {
        id: "billing-history",
        label: "Billing History",
        icon: <HistoryOutlinedIcon />,
        children: [
          {
            id: "transactions",
            label: "Transactions",
          },
          {
            id: "invoices",
            label: "Invoices",
          },
          {
            id: "receipts",
            label: "Receipts",
          },
        ],
      },

      {
        id: "billing-information",
        label: "Billing Information",
        icon: <ReceiptLongOutlinedIcon />,
        children: [
          {
            id: "billing-details",
            label: "Billing Details",
          },
          {
            id: "billing-address",
            label: "Billing Address",
          },
        ],
      },
    ],
  },

  {
    id: "manage-notifications",
    title: "Manage Notifications",
    items: [
      {
        id: "notification-preferences",
        label: "Notification Preferences",
        icon: <NotificationsOutlinedIcon />,
        children: [
          {
            id: "general-notifications",
            label: "General Notifications",
          },
          {
            id: "system-notifications",
            label: "System Notifications",
          },
          {
            id: "account-notifications",
            label: "Account Notifications",
          },
        ],
      },

      {
        id: "transaction-notifications",
        label: "Transaction Notifications",
        icon: <ReceiptLongOutlinedIcon />,
        children: [
          {
            id: "sales-notifications",
            label: "Sales",
          },
          {
            id: "purchase-notifications",
            label: "Purchases",
          },
          {
            id: "stock-notifications",
            label: "Stock & Inventory",
          },
          {
            id: "payment-notifications",
            label: "Payments",
          },
        ],
      },

      {
        id: "notification-channels",
        label: "Notification Channels",
        icon: <SendOutlinedIcon />,
        children: [
          {
            id: "email-notifications",
            label: "Email",
          },
          {
            id: "sms-notifications",
            label: "SMS",
          },
          {
            id: "push-notifications",
            label: "Push Notifications",
          },
          {
            id: "in-app-notifications",
            label: "In-App Notifications",
          },
        ],
      },

      {
        id: "notification-history",
        label: "Notification History",
        icon: <HistoryOutlinedIcon />,
        children: [
          {
            id: "sent-notifications",
            label: "Sent Notifications",
          },
          {
            id: "failed-notifications",
            label: "Failed Notifications",
          },
        ],
      },
    ],
  },
  {
    id: "add",
    title: "Public API (beta)",
    items: [
      {
        id: "api-overview",
        label: "API Overview",
        icon: <ApiOutlinedIcon />,
        children: [
          {
            id: "api-introduction",
            label: "Introduction",
          },
          {
            id: "api-status",
            label: "API Status",
          },
        ],
      },

      {
        id: "api-credentials",
        label: "API Credentials",
        icon: <KeyOutlinedIcon />,
        children: [
          {
            id: "api-keys",
            label: "API Keys",
          },
          {
            id: "create-api-key",
            label: "Create API Key",
          },
        ],
      },

      {
        id: "api-documentation",
        label: "API Documentation",
        icon: <DescriptionOutlinedIcon />,
        children: [
          {
            id: "authentication",
            label: "Authentication",
          },
          {
            id: "endpoints",
            label: "Endpoints",
          },
          {
            id: "request-response",
            label: "Request & Response",
          },
        ],
      },

      {
        id: "webhooks",
        label: "Webhooks",
        icon: <WebhookOutlinedIcon />,
        children: [
          {
            id: "webhook-endpoints",
            label: "Webhook Endpoints",
          },
          {
            id: "create-webhook",
            label: "Create Webhook",
          },
          {
            id: "webhook-events",
            label: "Webhook Events",
          },
        ],
      },
      {
        id: "api-activity",
        label: "API Activity",
        icon: <TimelineOutlinedIcon />,
        children: [
          {
            id: "api-requests",
            label: "API Requests",
          },
          {
            id: "api-errors",
            label: "API Errors",
          },
        ],
      },
    ],
  },
];

const ClientProfileDashboard = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const [timeLeft, setTimeLeft] = useState({
    days: 0,
    hours: 0,
    minutes: 0,
    seconds: 0,
    expired: false,
  });
  const [loading, setLoading] = useState(false);
  const redirect = useNavigate();
  const activeTab = searchParams.get("page") || "personal-profile";
  const requestedSecondary = searchParams.get("section");
  const handleTabChange = (tab) => {
    if (!showProfileSection(tab)) return;
    setSearchParams({ page: tab });
  };
  const { clientData, accessFeatures } = useSelector(
    (state) => state.clientFunction?.companiesDB,
  );
  const access = useAccess();
  const profileAccess = (id) => {
    if (id === "access-control") {
      const decision = access.check({ module: "staff", capability: "staff.view", permission: "staff.view" });
      return decision;
    }
    if (id === "add") return access.check({ module: "api", capability: "api.view", permission: "api.view" });
    return { allowed: true };
  };
  const [profileNotice, setProfileNotice] = useState("");
  const showProfileSection = (id) => {
    const decision = profileAccess(id);
    if (!decision.allowed) {
      setProfileNotice(access.message(decision, id === "add" ? "Public API" : "Staff Access Control"));
      return false;
    }
    setProfileNotice("");
    return true;
  };
  const expiryProgress = subscriptionProgress(clientData?.subscription);
  const [activePrimary, setActivePrimary] = useState(() =>
    primaryNavigation.some((item) => item.id === activeTab) ? activeTab : "dashboard",
  );

  const [activeSecondary, setActiveSecondary] = useState(() => {
    const section = secondaryNavigation.find((item) => item.id === activeTab);
    return !!findNavigationPath(section?.items||[],requestedSecondary)?.length
      ? requestedSecondary
      : section?.items?.[0]?.id || "recent-activity";
  });

  const [openSections, setOpenSections] = useState({
    overview: true,
    "ui-ux-design": true,
    "products-designs": true,
  });

  const [openBreadcrumb, setOpenBreadcrumb] = useState(null);

  const toggleSection = (id) => {
    setOpenSections((previous) => ({
      ...previous,
      [id]: !previous[id],
    }));
  };

  useEffect(() => {
    const section = secondaryNavigation.find((item) => item.id === activeTab);
    if (!section) return;
    setActivePrimary(activeTab);
    setActiveSecondary(!!findNavigationPath(section.items||[],requestedSecondary)?.length
      ? requestedSecondary : section.items?.[0]?.id || "recent-activity");
    setOpenBreadcrumb(null);
  }, [activeTab, requestedSecondary]);

  const handlePrimaryNavigation = (id) => {
    if (!showProfileSection(id)) return;
    setSearchParams({ page: id });
    setActivePrimary(id);
    setOpenBreadcrumb(null);

    const section = secondaryNavigation.find((item) => item.id === id);

    if (section?.items?.length) {
      setActiveSecondary(section.items[0].id);
    }
  };

  const handleSecondaryNavigation = (item) => {
    setActiveSecondary(item.id);
    setOpenBreadcrumb(null);
  };

  function findNavigationPath(items, targetId, path = []) {
    for (const item of items) {
      const currentPath = [...path, item];

      if (item.id === targetId) {
        return currentPath;
      }

      if (item.children?.length) {
        const result = findNavigationPath(item.children, targetId, currentPath);

        if (result) {
          return result;
        }
      }
    }

    return null;
  }

  const activePrimarySection = secondaryNavigation.find(
    (section) => section.id === activePrimary,
  );

  const activeNavigationPath = activePrimarySection
    ? findNavigationPath(activePrimarySection.items, activeSecondary) || []
    : [];

  const breadcrumbItems = [
    {
      id: "dashboard-root",
      label: activePrimarySection?.title || "Dashboard",
      type: "root",
    },
    ...activeNavigationPath,
  ];

  const renderNestedItems = (items, parentId, level = 0) => {
    if (!items?.length) {
      return null;
    }

    return (
      <div
        className={
          level === 0
            ? "ClientProfileSubNavChildren"
            : "ClientProfileNestedChildren"
        }
      >
        {items.map((item) => {
          const hasChildren =
            Array.isArray(item.children) && item.children.length > 0;

          const isOpen = openSections[item.id];

          const isActive = activeSecondary === item.id;

          return (
            <div className="ClientProfileNavBranch" key={item.id}>
              <div
                className={
                  isActive
                    ? "ClientProfileSubNavItem active"
                    : "ClientProfileSubNavItem"
                }
              >
                <button
                  type="button"
                  className="ClientProfileSubNavButton"
                  onClick={() => handleSecondaryNavigation(item)}
                >
                  <span className="ClientProfileBranchLine" />

                  <span className="ClientProfileSubNavLabel">{item.label}</span>

                  {item.badge && (
                    <span className="ClientProfileNavBadge">{item.badge}</span>
                  )}

                  {hasChildren && (
                    <button
                      type="button"
                      className={
                        isOpen
                          ? "ClientProfileNestedArrow active"
                          : "ClientProfileNestedArrow"
                      }
                      onClick={(event) => {
                        event.stopPropagation();
                        toggleSection(item.id);
                      }}
                    >
                      <KeyboardArrowDownRoundedIcon />
                    </button>
                  )}

                  {!hasChildren && !item.badge && (
                    <ChevronRightRoundedIcon className="ClientProfileSubNavChevron" />
                  )}
                </button>
              </div>

              {hasChildren && isOpen && (
                <div className="ClientProfileNestedTree">
                  {renderNestedItems(item.children, item.id, level + 1)}
                </div>
              )}
            </div>
          );
        })}
      </div>
    );
  };

  const pad = (value) => value.toString().padStart(2, "0");

  function functionalDisplayComponent() {
    const decision = profileAccess(activePrimary);
    if (!decision.allowed) return <div role="status" className="pd4 fs3">{access.message(decision, activePrimary === "add" ? "Public API" : "Staff Access Control")}</div>;
    switch (activePrimary) {
      case "dashboard":
        return (
          <ProfileDashboard
            data={clientData}
            activePrimary={activePrimary}
            breadcrumbItems={breadcrumbItems}
            activePrimarySection={activePrimarySection}
            openBreadcrumb={openBreadcrumb}
            activeSecondary={activeSecondary}
            setOpenBreadcrumb={setOpenBreadcrumb}
            setActiveSecondary={setActiveSecondary}
          />
        );

      case "access-control":
        return <StaffWorkspace key={activeSecondary} setLoading={setLoading} clientData={clientData} activeSecondary={activeSecondary} />;
      case "company-profile":
      case "billings":
      case "manage-notifications":
      case "add":
        return <ProfileDashboard data={clientData} activePrimary={activePrimary} activeSecondary={activeSecondary} />;
      default:
        return (
          <ProfileDashboard
            data={clientData}
            breadcrumbItems={breadcrumbItems}
            activePrimarySection={activePrimarySection}
            openBreadcrumb={openBreadcrumb}
            activeSecondary={activeSecondary}
            setOpenBreadcrumb={setOpenBreadcrumb}
            setActiveSecondary={setActiveSecondary}
          />
        );
    }
  }

  useEffect(() => {
    const expiryDate = clientData?.subscription?.expiryDate;

    if (!expiryDate) return;

    const interval = setInterval(() => {
      const now = Date.now();
      const expiry = new Date(expiryDate).getTime();

      const distance = expiry - now;

      if (distance <= 0) {
        setTimeLeft({
          days: 0,
          hours: 0,
          minutes: 0,
          seconds: 0,
          expired: true,
        });

        clearInterval(interval);
        return;
      }

      setTimeLeft({
        days: Math.floor(distance / (1000 * 60 * 60 * 24)),
        hours: Math.floor(
          (distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60),
        ),
        minutes: Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60)),
        seconds: Math.floor((distance % (1000 * 60)) / 1000),
        expired: false,
      });
    }, 1000);

    return () => clearInterval(interval);
  }, [clientData?.subscription?.expiryDate]);
  return (
    <div className="ClientProfileDashboardWrapper">
      {profileNotice && <div role="alert" className="pd3 fs2">{profileNotice} <button type="button" onClick={() => setProfileNotice("")}>Dismiss</button></div>}
      <div className="ClientProfileDashboard fx-cl">
        <header className="ClientProfileDashboardHeader fx-ac fx-jb space3">
          <div className="fx-ac space2">
            <nav className="fx space1 fs2 fw500">
              <span onClick={() => redirect(`/`)}>
                <HomeOutlinedIcon />
              </span>
              <span onClick={() => handleTabChange("plan-billing")}>
                <SubscriptionsOutlinedIcon />
              </span>
            </nav>
          </div>
          <figure className="fx-ac spacem">
            <span>@</span>
            <span className="fs1 fw600">universeinventory.com</span>
          </figure>
          <div
            className="fx-ac spacem"
           
          >
            <DashboardOutlinedIcon /> <span>Workspace</span>
          </div>
        </header>

        <div className="ClientProfileDashboardShell">
          {/* =====================================================
            PRIMARY ICON NAVIGATION
        ====================================================== */}

          <aside className="ClientProfilePrimarySidebar">
            <div className="ClientProfilePrimaryTop">
              <div className="ClientProfileBrandMark">
                <AppsRoundedIcon />
              </div>

              <div className="ClientProfilePrimaryDivider" />

              <nav className="ClientProfilePrimaryNavigation">
                {primaryNavigation.map((item) => {
                  const active = activePrimary === item.id;

                  return (
                    <button
                      key={item.id}
                      type="button"
                      aria-label={item.label}
                      title={item.label}
                      className={
                        active
                          ? "ClientProfilePrimaryNavItem active"
                          : "ClientProfilePrimaryNavItem"
                      }
                      onClick={() => handlePrimaryNavigation(item.id)}
                    >
                      {active && (
                        <span className="ClientProfilePrimaryActiveBar" />
                      )}

                      <span className="ClientProfilePrimaryIcon">
                        {item.icon}
                      </span>
                    </button>
                  );
                })}
              </nav>
            </div>

            <div className="ClientProfilePrimaryBottom">
              <button
                type="button"
                className="ClientProfilePrimaryNavItem"
                aria-label="Settings"
                title="Settings"
              >
                <span className="ClientProfilePrimaryIcon">
                  <SettingsOutlinedIcon />
                </span>
              </button>

              <button
                type="button"
                className="ClientProfilePrimaryNavItem"
                aria-label="Logout"
                title="Logout"
              >
                <span className="ClientProfilePrimaryIcon">
                  <LogoutRoundedIcon />
                </span>
              </button>
            </div>
          </aside>

          <div className="ClientProfileMainContainerWraps fx">
            {/* =====================================================
            SECONDARY NAVIGATION
        ====================================================== */}

            <aside className="ClientProfileSecondarySidebar">
              <div className="ClientProfileSecondaryHeader fx fx-ac fx-jb">
                <div className="fx fx-ac space">
                  <div className="ClientProfileSecondaryHeaderIcon fx fx-ac fx-jc">
                    <CloudOutlinedIcon />
                  </div>

                  <strong>Dashboard</strong>
                </div>

                <button
                  type="button"
                  className="ClientProfileSidebarCollapse"
                  aria-label="Collapse navigation"
                >
                  <ChevronRightRoundedIcon />
                </button>
              </div>

              {/* SEARCH */}

              <div className="ClientProfileSearch">
                <SearchRoundedIcon />

                <input type="search" placeholder="Search" />

                <span className="ClientProfileSearchShortcut">⌘ K</span>
              </div>

              {/* NAVIGATION */}

              <nav className="ClientProfileSecondaryNavigation">
                {secondaryNavigation
                  .find((section) => section.id === activePrimary)
                  ?.items.map((section) => {
                    const hasChildren = section.children?.length > 0;
                    const isOpen = openSections[section.id];
                    const isSectionActive = activeSecondary === section.id;

                    return (
                      <div
                        className={
                          isSectionActive
                            ? "ClientProfileSecondarySection active"
                            : "ClientProfileSecondarySection"
                        }
                        key={section.id}
                      >
                        <div
                          className={
                            isSectionActive
                              ? "ClientProfileSectionHeader active"
                              : "ClientProfileSectionHeader"
                          }
                        >
                          <button
                            type="button"
                            className="ClientProfileSectionHeaderButton"
                            onClick={() => {
                              if (hasChildren) {
                                toggleSection(section.id);
                              }
                              setActiveSecondary(section.id);
                            }}
                          >
                            <span className="ClientProfileSectionIcon">
                              {section.icon}
                            </span>
                            <span className="ClientProfileSectionTitle">
                              {section.label}
                            </span>

                            {section.editable && (
                              <span className="ClientProfileEditIcon">
                                <MoreVertRoundedIcon />
                              </span>
                            )}

                            {hasChildren && (
                              <span
                                className={
                                  isOpen
                                    ? "ClientProfileSectionArrow active"
                                    : "ClientProfileSectionArrow"
                                }
                              >
                                <KeyboardArrowDownRoundedIcon />
                              </span>
                            )}

                            {!hasChildren && !section.editable && (
                              <ChevronRightRoundedIcon className="ClientProfileSectionChevron" />
                            )}
                          </button>
                        </div>

                        {hasChildren && isOpen && (
                          <div className="ClientProfileSectionTree">
                            {renderNestedItems(section.children, section.id)}
                          </div>
                        )}
                      </div>
                    );
                  })}
              </nav>

              {/* NEW FOLDER */}

              <button type="button" className="ClientProfileNewFolderButton" 
               onClick={() =>
              redirect(
                `/advance-companies-management-system/company-account?notation=${clientData?._id}`,
              )
            }>
                <AddRoundedIcon />

                <span>Luanch Inventory</span>
              </button>

              {/* TRIAL CARD */}

              <div className="ClientProfileTrialCard">
                <button
                  type="button"
                  className="ClientProfileTrialMore"
                  aria-label="More options"
                >
                  <MoreVertRoundedIcon />
                </button>

                <div className="ClientProfileRocket">
                  <RocketLaunchRoundedIcon />
                </div>

                <strong>{clientData?.subscription?.planName || "Subscription"}</strong>

                <p>
                  {expiryProgress.expired ? "Your subscription has expired" : "Your subscription expires in"}
                  <span className="fx-cl spacem">
                    <span className="fw600 fs6 fx-jc">
                      {timeLeft.expired
                        ? "Expired"
                        : `${pad(timeLeft.days)}:${pad(timeLeft.hours)}:${pad(
                            timeLeft.minutes,
                          )}:${pad(timeLeft.seconds)}`}
                    </span>
                    {/* {!timeLeft.expired && (
                      <span className="fs2 cb fx-jc">
                        Days : Hours : Minutes : Seconds
                      </span>
                    )} */}
                  </span>
                  . Upgrade now for access!
                </p>
                <button type="button" className="ClientProfileUpgradeButton" onClick={() => handlePrimaryNavigation("billings")}>
                  <AutoAwesomeRoundedIcon />
                  Upgrade here
                </button>
              </div>
            </aside>

            {/* =====================================================
            MAIN CONTENT
        ====================================================== */}

            <main className="ClientProfileMainContent fx-cl space3">
              <div className="ClientProfileContentTop">
                <div className="ClientProfileStorageBar">
                  <div className="fx fx-ac space">
                    <div className="ClientProfileStorageIcon fx fx-ac fx-jc">
                      <CloudOutlinedIcon />
                    </div>

                    <strong>{clientData?.subscription?.planName || "Subscription"}</strong>
                  </div>

                  <span>{expiryProgress.remaining === null ? "Expiry unavailable" : expiryProgress.expired ? "Expired" : `${expiryProgress.remaining} days remaining`}</span>
                </div>

                <div className="ClientProfileStorageProgress" role="progressbar" aria-label="Subscription period elapsed" aria-valuenow={expiryProgress.percent} aria-valuemin={0} aria-valuemax={100}>
                  <span style={{width: `${expiryProgress.percent}%`}} />
                </div>

                {/* =================================================
                BREADCRUMB
            ================================================== */}

                <nav
                  className="ClientProfileBreadcrumb"
                  aria-label="Breadcrumb"
                >
                  {breadcrumbItems.map((item, index) => {
                    const isLast = index === breadcrumbItems.length - 1;

                    const availableItems =
                      index === 0
                        ? activePrimarySection?.items || []
                        : item.children || [];

                    const hasDropdown = availableItems.length > 0;

                    const isDropdownOpen = openBreadcrumb === item.id;

                    return (
                      <React.Fragment key={item.id}>
                        <div className="ClientProfileBreadcrumbItem">
                          <button
                            type="button"
                            className={
                              isLast
                                ? "ClientProfileBreadcrumbButton active"
                                : "ClientProfileBreadcrumbButton"
                            }
                            onClick={() => {
                              if (hasDropdown) {
                                setOpenBreadcrumb(
                                  isDropdownOpen ? null : item.id,
                                );
                              } else {
                                setActiveSecondary(item.id);
                                setOpenBreadcrumb(null);
                              }
                            }}
                          >
                            <span>{item.label}</span>

                            {!isLast && item.badge && (
                              <span className="ClientProfileBreadcrumbBadge">
                                {item.badge}
                              </span>
                            )}

                            {hasDropdown && (
                              <KeyboardArrowDownRoundedIcon
                                className={
                                  isDropdownOpen
                                    ? "ClientProfileBreadcrumbDropdown open"
                                    : "ClientProfileBreadcrumbDropdown"
                                }
                              />
                            )}
                          </button>

                          {hasDropdown && isDropdownOpen && (
                            <div className="ClientProfileBreadcrumbMenu">
                              {availableItems.map((child) => {
                                const childHasChildren =
                                  child.children?.length > 0;

                                const childActive =
                                  activeSecondary === child.id;

                                return (
                                  <button
                                    key={child.id}
                                    type="button"
                                    className={
                                      childActive
                                        ? "ClientProfileBreadcrumbMenuItem active"
                                        : "ClientProfileBreadcrumbMenuItem"
                                    }
                                    onClick={() => {
                                      setActiveSecondary(child.id);

                                      if (childHasChildren) {
                                        setOpenBreadcrumb(child.id);
                                      } else {
                                        setOpenBreadcrumb(null);
                                      }
                                    }}
                                  >
                                    <span className="ClientProfileBreadcrumbMenuLabel">
                                      {child.label}
                                    </span>

                                    {child.badge && (
                                      <span className="ClientProfileBreadcrumbMenuBadge">
                                        {child.badge}
                                      </span>
                                    )}

                                    {childHasChildren && (
                                      <ChevronRightRoundedIcon />
                                    )}
                                  </button>
                                );
                              })}
                            </div>
                          )}
                        </div>

                        {!isLast && (
                          <ChevronRightRoundedIcon className="ClientProfileBreadcrumbSeparator" />
                        )}
                      </React.Fragment>
                    );
                  })}
                </nav>
              </div>
              {functionalDisplayComponent()}
            </main>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ClientProfileDashboard;
